import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as localStorageActions from 'automation-ui-canvas/actions/LocalStorageActions';
import { getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import { getUserEditedActionIds } from 'automation-ui-canvas/selectors/flowSelectors';
import { routeToSpecificAction } from 'automation-ui-canvas/utils/routingUtils';
import { getIsEmbedded } from 'automation-ui-canvas/selectors/embedSelectors';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import { getZoomLevel } from 'automation-ui-canvas/selectors/localStorageSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import H5 from 'UIComponents/elements/headings/H5';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { AddIcon, RemoveIcon } from 'foundations-assets';
import { TooltipTypes, TooltipConfig } from 'automation-ui-canvas/constants/TooltipTypes';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { wireFlowById } from 'automation-ui-canvas/queries/flowQueries';
import { WORKFLOW } from 'automation-ui-canvas/flow/constants/FlowTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class AddButton extends Component {
  /**
   * This component should only ever update if the
   * necessary props are updated. We use this lifecycle
   * method to avoid route changes updating the icon
   */
  shouldComponentUpdate({
    isSelected
  }) {
    return isSelected !== this.props.isSelected;
  }
  render() {
    const {
      isSelected
    } = this.props;
    if (isSelected) {
      return /*#__PURE__*/_jsx(RemoveIcon, {});
    } else {
      return /*#__PURE__*/_jsx(AddIcon, {});
    }
  }
}
export class AddButtonWithTooltips extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      disablePermanently: false,
      tooltipType: ''
    };
    this.dismiss = event => {
      const {
        disablePermanently,
        tooltipType
      } = this.state;
      TooltipConfig[tooltipType].onDismiss({
        trackEvent
      });
      if (disablePermanently) {
        trackEvent(Trackables.TOOLTIP_DISABLED, {
          type: tooltipType
        });
      }
      this.close(event);
    };
    this.close = event => {
      const {
        disabledTooltips,
        dismissedTooltips,
        edgeId,
        flowId,
        mergeDeepWithLocalStorage
      } = this.props;
      const {
        disablePermanently,
        tooltipType
      } = this.state;
      event.stopPropagation();
      mergeDeepWithLocalStorage({
        disabledTooltips: disablePermanently ? disabledTooltips.concat([tooltipType]) : disabledTooltips,
        dismissedTooltips: {
          [`${flowId}-${edgeId}`]: dismissedTooltips.concat([tooltipType])
        }
      });
    };
    this.onClickAdd = event => {
      const {
        flow,
        edgeId,
        flowId,
        history,
        isEmbedded
      } = this.props;
      const {
        disablePermanently,
        tooltipType
      } = this.state;
      if (disablePermanently) {
        trackEvent(Trackables.TOOLTIP_DISABLED, {
          type: tooltipType
        });
      }
      if (TooltipConfig[tooltipType]) {
        const flowType = flow ? flow.flowType : WORKFLOW;
        TooltipConfig[tooltipType].onClickAdd({
          trackEvent,
          routeToAction: ({
            configId,
            extraParams
          }) => {
            routeToSpecificAction({
              history,
              edgeId,
              flowId: flowId,
              configId,
              extraParams,
              isEmbedded,
              flowType
            });
          }
        });
      }
      this.close(event);
    };
    this.onClickRecommendedAction = ({
      configId,
      extraParams
    }) => {
      const {
        flow,
        edgeId,
        flowId,
        history,
        isEmbedded
      } = this.props;
      const flowType = flow ? flow.flowType : WORKFLOW;
      routeToSpecificAction({
        history,
        edgeId,
        flowId: flowId,
        configId,
        extraParams,
        isEmbedded,
        flowType
      });
    };
  }
  componentDidMount() {
    this.loadTooltips();
  }
  componentDidUpdate(prevProps) {
    var _userEditedActionIds$, _prevProps$userEdited;
    const {
      tooltipsToRestore,
      fromActionId,
      toActionId,
      userEditedActionIds,
      flowId
    } = this.props;
    const editedActionIds = (_userEditedActionIds$ = userEditedActionIds.get(flowId)) === null || _userEditedActionIds$ === void 0 ? void 0 : _userEditedActionIds$.editedActionIds;
    const prevEditedActionIds = (_prevProps$userEdited = prevProps.userEditedActionIds.get(flowId)) === null || _prevProps$userEdited === void 0 ? void 0 : _prevProps$userEdited.editedActionIds;
    if (fromActionId !== prevProps.fromActionId || toActionId !== prevProps.toActionId || editedActionIds && !(editedActionIds !== null && editedActionIds !== void 0 && editedActionIds.equals(prevEditedActionIds)) || tooltipsToRestore.length !== prevProps.tooltipsToRestore.length) {
      this.loadTooltips();
    }
  }
  loadTooltips() {
    const {
      fromActionId,
      fromAction,
      toAction,
      tooltipsToRestore,
      userEditedActionIds,
      flowId
    } = this.props;
    const fromActionType = fromAction ? fromAction.getActionType() : null;
    const toActionType = toAction ? toAction.getActionType() : null;

    // In the case that there are multiple tooltips to restore, an ordering would be set here
    const tooltipType = Object.values(TooltipTypes).find(type => tooltipsToRestore.includes(type) && TooltipConfig[type].shouldShow({
      fromActionType,
      toActionType
    }));
    if (tooltipType && userEditedActionIds.hasIn([flowId, 'editedActionIds', fromActionId])) {
      this.setState({
        tooltipType
      });
    } else {
      this.setState({
        tooltipType: ''
      });
    }
  }
  render() {
    const {
      showEdgeTooltips
    } = this.props;
    const {
      disablePermanently,
      tooltipType
    } = this.state;
    const addButton = /*#__PURE__*/_jsx(AddButton, {
      isSelected: this.props.isSelected
    });
    if (tooltipType && showEdgeTooltips === true) {
      return /*#__PURE__*/_jsx(UIPopover, {
        open: true,
        width: 400,
        placement: "right bottom",
        autoPlacement: false,
        content: {
          header: /*#__PURE__*/_jsx(H5, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `editor.tooltips.${tooltipType}.header`
            })
          }),
          body: /*#__PURE__*/_jsx("div", {
            children: I18n.lookup(`editor.tooltips.${tooltipType}.body_jsx`) ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: `editor.tooltips.${tooltipType}.body_jsx`,
              elements: {
                Bold: 'b',
                Link: UILink
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: `editor.tooltips.${tooltipType}.body`
            })
          }),
          footer: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs(UIButtonWrapper, {
              children: [/*#__PURE__*/_jsx(UIButton, {
                use: "tertiary",
                onClick: this.onClickAdd,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `editor.tooltips.${tooltipType}.confirm`
                })
              }), /*#__PURE__*/_jsx(UIButton, {
                use: "tertiary-light",
                onClick: this.dismiss,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `editor.tooltips.${tooltipType}.dismiss`
                })
              })]
            }), /*#__PURE__*/_jsx(UICheckbox, {
              size: "small",
              checked: disablePermanently,
              onChange: ({
                target: {
                  checked
                }
              }) => {
                this.setState({
                  disablePermanently: checked
                });
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `editor.tooltips.${tooltipType}.dismissPermanently`
              })
            })]
          })
        }
        // @ts-expect-error bad props for UIPopover
        ,
        onClick: event => event.stopPropagation(),
        children: addButton
      });
    }
    return addButton;
  }
}

// Return the set of tooltips that would appear but have been dismissed
const getDismissedTooltips = (localStorage, edgeId, flowId) => {
  const allDismissedTooltips = localStorage.get('dismissedTooltips');
  if (!allDismissedTooltips) return [];
  return allDismissedTooltips.get(`${flowId}-${edgeId}`) || [];
};

// Return the tooltip types that this user has turned off
const getDisabledTooltips = localStorage => {
  const disabledTooltips = localStorage.get('disabledTooltips');
  return disabledTooltips || [];
};
const mapStateToProps = (state, {
  edgeId,
  flowId,
  flow
}) => {
  // Convert possible NaN value to undefined
  const withUndefinedFromNaN = possibleNaN => isNaN(possibleNaN) ? undefined : possibleNaN;
  const dismissedTooltips = Array.from(getDismissedTooltips(state.localStorage, edgeId, flowId));
  const disabledTooltips = Array.from(getDisabledTooltips(state.localStorage));
  const tooltipsToRestore = Object.values(TooltipTypes).filter(type => !dismissedTooltips.includes(type) && !disabledTooltips.includes(type));
  const fromActionId = withUndefinedFromNaN(getPreviousActionId(edgeId));
  const fromAction = flow && fromActionId ? flow.getActionById(fromActionId) : undefined;
  const connection = fromAction ? fromAction.getConnection() : undefined;
  const toActionId = withUndefinedFromNaN(
  // Come back and fix the types for ConnectionMixin
  connection && !connection.isBranchConnection() ? connection.getNextActionId() : undefined);
  const toAction = toActionId ? flow.getActionById(toActionId) : undefined;
  const isEmbedded = getIsEmbedded(state);
  return {
    flowId,
    userEditedActionIds: getUserEditedActionIds(state),
    disabledTooltips,
    dismissedTooltips,
    fromAction,
    fromActionId,
    isEmbedded,
    toAction,
    toActionId,
    tooltipsToRestore,
    zoomLevel: getZoomLevel(flowId)(state)
  };
};
export default compose(wireFlowById, connect(mapStateToProps, {
  mergeDeepWithLocalStorage: localStorageActions.mergeDeepWithLocalStorage
}))(AddButtonWithTooltips);